import type { IconData } from '../../types';

export const data: IconData = {
  o: '<path d="M96-406q-13 0-22-9-8-9-8-22t9-21q8-9 21-9h769q12 0 21 9t9 22q0 12-9 21t-22 9H96Zm324-121v-168H245q-25 0-42-18-17-17-17-42t17-42q17-18 42-18h470q25 0 42 18 18 17 18 42t-18 42q-17 18-42 18H540v168H420Zm0 181h120v141q0 24-17 42-18 17-43 17t-42-17q-18-18-18-43v-140Z"/>',
  f: '<path d="M96-406q-13 0-22-9-8-9-8-22t9-21q8-9 21-9h769q12 0 21 9t9 22q0 12-9 21t-22 9H96Zm324-121v-168H245q-25 0-42-18-17-17-17-42t17-42q17-18 42-18h470q25 0 42 18 18 17 18 42t-18 42q-17 18-42 18H540v168H420Zm0 181h120v141q0 24-17 42-18 17-43 17t-42-17q-18-18-18-43v-140Z"/>',
};

export default data;
